<template>
    <div>

        <TextBanner>
            <p>Auch im Winter kann in Katar das Thermometer auf bis zu 29 °C klettern. Dann blasen große Düsen kalte Luft auf das Spielfeld und sorgen in bis zu drei Metern Höhe für angenehme Temperaturen.</p>
            <p><b>Drücken Sie den blauen Punkt, um den Kühleffekt zu sehen.</b></p>

        </TextBanner>

        <InfoBox modalName="050anim">
            <template #title></template>
            <template #subline></template>
            <template>
            </template>
        </InfoBox>

        <InfoBox modalName="050b">
            <template #title>Klimatisierung der Ränge</template>
            <template #subline></template>
            <template>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/050b_Sitz.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="800" data-height="800" v-lazy="require('../assets/img/050b_Sitz_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; dpa</div>
                            Lüftungsgitter unter den Sitzen                          
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Nicht nur die Fußballer, sondern auch die Fans sollen es während der Spiele angenehm kühl haben. Dafür wird die heiße Außenluft abgekühlt und gelangt über Gitter unter den Sitzplätzen auf die Tribünen. Anschließend wird diese Luft wieder eingesaugt, erneut gekühlt, gefiltert und zurück ins Stadion geleitet. So bildet sich eine etwa zwei Meter hohe Kühlzone über den Zuschauer*innen.</p>


                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/050b_Solarpark.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="800" data-height="800" v-lazy="require('../assets/img/050b_Solarpark_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; afp</div>
                            Solarpark Al-Kharsaah                         
                        </figcaption>
                    </figure>
                </FullscreenImage>
                <p>Den Strom für die Stadien soll ein riesiges, neues Solarfeld außerhalb Dohas liefern. Ob diese Anlage wirklich für die WM genutzt wird, lässt sich allerdings nicht kontrollieren.</p>


            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [0,1.35,0.05],
                target: [-1.73,-4,0],
                fov: 1.8,  //1.6
                betaLimits: [0.1, 1.5],   //0.1,1,6
                //alphaLimits:[-1.65,1.65],
                radiusLimits: [.15,.15], // minCamRadius, maxCamRadius
                clipping: [.05, 10000.0],

            },
            
            lusail:{
                // Luftpolster_kalt: {
                //     visible: true
                //     },
                // Luftpolster_warm: {
                //     visible: true
                //     },

                detail_lueftung:{
                    pickable: false,
                },

                TEX_Bande: {
                    pickable: false
                },

                TEX_Bake_Tribuene:{
                    pickable: false
                },

                Temperaturverlauf_Boden: {
                    visible: true,
                    pickable: false,
                    //renderingGroupId: 0,
                    },

                Temperaturverlauf: {
                    visible: true,
                    pickable: false,
                    //renderingGroupId: 0,
                    },

                Wanne_kalt:{
                    visible: true,
                    renderingGroupId: 1,
                },

                Spieler: {
                    visible: true,
                    renderingGroupId: 2,
                    },

                Label_19Grad:{
                    visible: true,
                    renderingGroupId: 2,
                    //billboardMode: 2,
                        Typo_19Grad: {
                            visible: true,
                            renderingGroupId: 2,

                        }
                    },

                Label_23Grad:{
                    visible: true,
                    renderingGroupId: 2,
                        Typo_23Grad: {
                            visible: true,
                            renderingGroupId: 2,
                        }
                    },

                Temperaturverlauf_warm:{
                    pickable: false,
                    visible: true,
                    renderingGroupId: 1,

                },

            },

            hotspots: {

                info050anim: {
                    visible: true,
                    //infoBox: '050anim',
                    position: [-1.86, -3.97, -.02],
                    scale: .1,
                    renderingGroupId: 2,
                    imgUrl: 'texture/hotspotSprite_tuerkis.png', // optional

                    trigger: (babylonController) => {


                           //babylonController.goToAnimation("anim_orion_ankommen", 50);

                            babylonController.startAnimation("anim_boden", false, .2);  //.3
                            babylonController.startAnimation("anim_verlauf", false,.6);
                            babylonController.startAnimation("anim_wanne", false, .1);   //.15
                            babylonController.startAnimation("anim_19Grad", false, 1);
                            babylonController.startAnimation("anim_23Grad", false, 1);
                            babylonController.startAnimation("anim_verlauf_warm", false, .5);





                            // weiter weg Versuch babylonController.moveCamera(0,1.4,1,-1.5,-3.96,0);   //0,1.4,0.05,-1.7,-3.98,0
                            babylonController.moveCamera(3,1.2,0.05,-1.5,-3.97,0);   //2.7,1.4,0.05,-1.5,-3.96,0


                            
                    },
                },

                info050b: {
                    visible: true,
                    infoBox: '050b',
                    position: [-2.5, -3.7, .2],
                    scale: .3,
                    renderingGroupId: 2,
                },
            },
           
        },
        babylonReady: function () {
            this.$babylonController.goToAnimation("anim_boden", 0);
            this.$babylonController.goToAnimation("anim_verlauf", 0);
            this.$babylonController.goToAnimation("anim_wanne", 0);
            this.$babylonController.goToAnimation("anim_19Grad", 0);
            this.$babylonController.goToAnimation("anim_23Grad", 0);
            this.$babylonController.goToAnimation("anim_verlauf_warm", 0);


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
